<script setup>
import HistoryBlock from "@/components/HistoryBlock";
import { RouterLink } from 'vue-router';
import { useWindowSize } from '@vueuse/core';
import { SUBSCRIBE_URL } from '@/data/links';
const { width } = useWindowSize();
// label — название бренда для alt логотипа: на картинках названия текстом,
// без alt они не попадают ни в индекс, ни в скринридер.
const brands = [
  {name: 'rossia', label: '«Россия» — щедрая душа!'},
  {name: 'nuts', label: 'NUTS'},
  {name: 'goodmix', label: 'GOODMIX', link: '/goodmix/promo'},
  {name: 'rodnye-prostory', label: 'Родные просторы', link: '/rp'},
  {name: 'bon-pari', label: 'Бон Пари'},
  {name: 'comilfo', label: 'Комильфо'},
  {name:'hrutka', label: 'Хрутка', link: 'https://hrutka.ru/'}
]
const articles = [
  {type: 'Энциклопедия', title: 'Пойдем, покажу, как&nbsp;делают шоколад', link: '/kakao-academy'},
  {type: 'Статья', title: 'История шоколада Nestlé', link: '/kakao-academy/article/history', notReady: true},
  {type: 'Статья', title: 'Как какао-бобы превращаются в&nbsp;шоколад', link: '/kakao-academy/article/processing', notReady: true},
  {type: 'Статья', title: 'Как закупают какао и&nbsp;что такое устойчивое производство', link: '/kakao-academy/article/buy', notReady: true},
  {type: 'Статья', title: 'Виды шоколада и&nbsp;начинки', link: '/kakao-academy/article/types', notReady: true}
]

</script>

<template>
  <div class="page page-home">
    <div class="top-block">
      <div class="top-block__slide">
        <div class="top-block__slide-text">
          <h1>
            <img src="@/assets/img/title1.svg" alt="" class="top-block__slide-title"/>
            <span class="visually-hidden">Мир сладких моментов Nestlé</span>
          </h1>
          <p>Шоколад, забота, качество и&nbsp;традиции — <br/>вдохновляем на&nbsp;радость каждый день!</p>
          <div class="top-block__slide-buttons">
            <router-link :to="{ name: 'home', hash: '#about' }">История фабрик</router-link>
            <router-link :to="{ name: 'home', hash: '#brands' }" class="_bordered">
              {{ width > 767 ? 'Узнать больше о брендах' : 'Бренды' }}
            </router-link>
          </div>
        </div>
        <picture>
          <source srcset="@/assets/img/top-block-image-mobile.webp" media="(max-width: 767px)"/>
          <source srcset="@/assets/img/top-block-image-tablet.webp" media="(max-width: 1023px)"/>
          <!--source srcset="@/assets/img/top-slide1.webp" type="image/webp"/-->
          <img src="@/assets/img/top-block-image.webp" alt="Плитки молочного шоколада с начинкой" class="top-block__slide-image"/>
        </picture>
      </div>
    </div>
    <div class="brands" id="brands">
      <h2 class="brands__title">Бренды кондитерских изделий NESTLÉ</h2>
      <div class="brands__items">
        <template v-for="brand in brands" :key="brand.name">
          <a v-if="brand?.link" :href="brand.link" target="_blank" class="brands__item brands__item_link">
            <img :src="require(`@/assets/img/logos/${brand.name}.png`)" :alt="brand.label" />
          </a>
          <div v-else class="brands__item">
            <img :src="require(`@/assets/img/logos/${brand.name}.png`)" :alt="brand.label" />
          </div>
        </template>
      </div>
    </div>
    <div class="main-articles">
      <div class="main-articles__half main-articles__half_1">
        <div class="main-articles__item main-articles__item_1">
          <h4>{{ articles[0].type }}</h4>
          <h3><router-link :to="articles[0].link" v-html="articles[0].title"></router-link></h3>
          <router-link :to="articles[0].link" class="main-articles__item-button">Узнать больше</router-link>
        </div>
      </div>
      <div class="main-articles__half main-articles__half_2">
        <div v-for="(item, index) in articles.slice(1)" :key="index" :class="['main-articles__item', `main-articles__item_${index + 2}`]">
          <h4>
            <span>{{ item.type }}</span>
            <template v-if="item?.notReady">
              <svg width="3" height="3" viewBox="0 0 3 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="1.46189" cy="1.46189" r="1.46189" fill="white"/>
              </svg>
              <span>скоро</span>
            </template>
          </h4>
          <!-- notReady — статья ещё не опубликована: заголовок остаётся на
               месте с пометкой «скоро», но ссылкой не становится. -->
          <h3>
            <component
              :is="item.notReady ? 'span' : RouterLink"
              :to="item.notReady ? undefined : item.link"
              v-html="item.title"
            ></component>
          </h3>
        </div>
      </div>
    </div>
    <history-block id="about"/>
    <div class="subscribe">
      <div class="subscribe__inner">
        <h2>Подписаться <br/>на рассылку</h2>
        <p>Узнавайте первыми об акциях и&nbsp;сладких новинках <br/>от наших брендов!</p>
        <a :href="SUBSCRIBE_URL" target="_blank">Перейти к подписке</a>
      </div>
    </div>
  </div>
</template>
